<template>
    <div class="text-center">
        <v-dialog
            v-model="show"
            width="unset"
            max-width="500"
            tabindex="-1"
            role="dialog"
            transition="v-expand-y-transition"
            persistent
        >
            <v-card
                class="elevation-12"
                max-width="330px"
                transition="v-expand-y-transition"
            >
                <v-container class="pa-7">
                    <div class="d-flex justify-center mb-6">
                        <v-img
                            src="/svg/undraw_informed_decision_p2lh.svg"
                            max-width="170"
                        />
                    </div>
                    <h3 class="text-center mb-4">
                        Well Done!! You are Almost There
                    </h3>
                    <h2 class="text-center mb-6 primary--text">
                        Get Started by
                    </h2>
                    <p class="mb-6">
                        <ol>
                            <li>Updating Contact Information.</li>
                            <li>Adding Delivery Method.</li>
                            <li>Adding Payment Method.</li>
                        </ol>
                    </p>
                    <v-btn
                        :to="{
                            name: 'user-settings',
                            hash: '#address',
                        }"
                        color="primary"
                        class="text-none white--text rounded-lg mb-3"
                        depressed
                        small
                        block
                        dark
                    >
                        Skip Tutorial
                    </v-btn>
                    <v-btn
                        color="grey"
                        class="text-none rounded-lg"
                        depressed
                        small
                        block
                        dark
                        @click="showTutorial"
                    >
                        Proceed with Tutorial
                    </v-btn>
                </v-container>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    export default {
        props: {
            value: {
                type: Boolean,
                required: true,
            },
        },
        computed: {
            show: {
                get() {
                    return this.value;
                },
                set(value) {
                    this.$emit('input', value);
                },
            },
        },
        methods: {
            showTutorial() {
                this.showTutorialVideo('delivery', true);
            },
        },
    };
</script>
